<template>
  <div class="overlay" :class="{ active: show }" @click="onOverlayClicked"> </div>
</template>

<script lang="ts" setup>
import { useDashboard } from '@/store/Dashboard'
import { watchEffect } from 'vue'

defineProps({
  show: {
    type: Boolean,
    default: true,
  },
})

const dashboardStore = useDashboard()

const onOverlayClicked = () => {
  dashboardStore.actions.toggleSubSidebar()
}

watchEffect(() => {
  dashboardStore.getters.isSubSidebarOpen
    ? document.body.classList.add('fixed')
    : document.body.classList.remove('fixed')
})
</script>

<style lang="scss" scoped>
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 3;
  display: none;

  &.active {
    @media (max-width: 800px) {
      display: block;
    }
  }
}
</style>
